export const VERSION = '0.63.1'; // x-release-please-version
//# sourceMappingURL=version.mjs.map